import { useState, useEffect } from 'react';
import {
  buildClientLogoCandidateUrls,
  preloadFirstImageUrl,
} from '../utils/clientLogoUrl';
import { getRuntimeEnv } from '../utils/runtimeEnv';

/**
 * Hook para cargar el logo del cliente desde CloudFront (favicon.svg).
 * Si no existe, retorna null para usar el logo por defecto.
 */
export const useClientLogo = () => {
  const [logoUrl, setLogoUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const cloudFrontUrl = getRuntimeEnv('REACT_APP_CLOUDFRONT_S3_URL');
    const clientName = getRuntimeEnv('REACT_APP_CLIENT_NAME');
    const candidates = buildClientLogoCandidateUrls(clientName, cloudFrontUrl);

    if (candidates.length === 0) {
      setLogoUrl(null);
      setIsLoading(false);
      return;
    }

    preloadFirstImageUrl(candidates).then((resolvedUrl) => {
      if (!cancelled) {
        setLogoUrl(resolvedUrl);
        setIsLoading(false);
      }
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return { logoUrl, isLoading };
};
